import { coordinate } from 'utils/eventContract'
import { useParams } from 'react-router-dom'
import { useState, useEffect}  from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { MdArrowBackIosNew } from 'react-icons/md'
import { getSingleEventData, getEventDiscussionComments, getSingleEventDataLoggedIn, setViewRsvpModal } from 'features/events/eventSlice'
import { dateObj } from 'features/constants'
import styled from 'styled-components'
import Loader from 'loaders/Loader'
import Details from 'components/events/singlePageEventComponents/Details'
import Discussion from 'components/events/singlePageEventComponents/Discussion' 
import useImageLoader from 'hooks/useImageLoader'

import EventMap from 'components/events/singlePageEventComponents/EventMap' 
import { Modal  } from '@mui/material' 
import RsvpModal from 'components/events/singlePageEventComponents/RsvpModal'
import ModalContainer from 'components/modal/ModalContainer'
import { TopRightItemContainer, SectionButton, SectionBtn, SinglePageContainer, SinglePageWrap, SinglePageLeft, SinglePageRight, RightMainContent } from 'pages/pages.styled'
import { TbListDetails } from "react-icons/tb";
import { GoCommentDiscussion } from "react-icons/go";
import { pBtnSmall } from 'components/main.styled'
import { PiMapPinLineLight } from "react-icons/pi";
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'

export default function SingleEventPage(props) {
  const { t: translate } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { eventId } = useParams()
    const {singlePageEventData, isSingleEventLoading, singleEventPrivacy, isResponseSuccess, viewRsvpModal } = useSelector((state) => state.events)
    const [date, setDate] = useState(null)
    const [privacy, setPrivacy] = useState('')
    const [attending, setAttending] = useState(false)
    const [ contentView, setContentView ] = useState('details')
    const handleClick = () => { navigate(-1) }
    const [coordinates, setCoordinates] = useState(null)

    const [imageSource, { blur }] = useImageLoader(
        singlePageEventData?.image?.urlSmall || null,
        singlePageEventData?.image?.url || null
    );

    // 3. Optional effect when image changes
    useEffect(() => {
        if (imageSource) {
        console.log("Image is now ready:", imageSource);
        }
    }, [imageSource]);

    useEffect(() => {
        if(user === null){
            if(singlePageEventData){ setDate(new Date(singlePageEventData.startDate)) };  return
        }else{ 
            if(singlePageEventData && singlePageEventData.attending){ 
                if(singlePageEventData.attending.find((item) => item._id === user._id)){  setAttending(true)
                } else  {  setAttending(false) }     
            }
        }
    }, [singlePageEventData, isResponseSuccess])

    useEffect(() => {
        const hasRequestedEvent = String(singlePageEventData?._id || '') === String(eventId)
        if(!hasRequestedEvent){
            if(user){ 
                dispatch(getSingleEventDataLoggedIn({ eventId: eventId }))
                dispatch(getEventDiscussionComments({ eventId: eventId, eventDiscussionCommentsArray: null }))
            }else{ 
                dispatch(getSingleEventData({ eventId: eventId }))
            }
        } else{ 
            dispatch(getEventDiscussionComments({ eventId: eventId, eventDiscussionCommentsArray: singlePageEventData.eventDiscussionComments }))
        }        
    }, [dispatch, eventId, user])

    useEffect(() => {
        if(singleEventPrivacy === 'members'){ setPrivacy('members')
        }else{  setPrivacy('public') }
    }, [singleEventPrivacy])

    useEffect(() => {
        const latitude = coordinate(singlePageEventData?.coordinates?.lat, 90)
        const longitude = coordinate(singlePageEventData?.coordinates?.lng, 180)
        if(
            singlePageEventData?.eventFormat !== 'online'
            && latitude !== null
            && longitude !== null
        ){
            setCoordinates([latitude.toString(), longitude.toString()])
        }else{
            setCoordinates(null)
        }
    }, [singlePageEventData])
    
  return (
        <SinglePageContainer>
            {user && (<div className='singlePostPostedToWrap'><div className='singlePostGoBack' onClick={handleClick}><MdArrowBackIosNew style={{marginRight: '10px'}} /> {translate('common:back')}</div></div>)}
            {
                singlePageEventData && (
                    isSingleEventLoading ? 
                    (
                        <Loader />
                    )
                    :
                    (
                        <SinglePageWrap addTopMargin={!user}>
                            <SinglePageLeft>
                                <ItemContainer>
                                    <img 
                                        onContextMenu={(e) => e.preventDefault()} 
                                        src={imageSource} alt='event' 
                                        style={{width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: '15px', borderTopRightRadius: '15px'}}/>
                                </ItemContainer>
                                <EventInfo>
                                    <ChurchInfo>
                                        <ChurchImage>
                                            {singlePageEventData?.church?.profileImg?.url ? (
                                                <img 
                                                    onContextMenu={(e) => e.preventDefault()} 
                                                    src={singlePageEventData.church.profileImg.url} 
                                                    alt="event"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '50%'
                                                    }}
                                                />
                                            ) : (
                                                <SpinnerSmall /> // or <Skeleton />
                                            )}
                                            </ChurchImage>
                                        <ChurchName>{singlePageEventData.church.fullName}</ChurchName>
                                    </ChurchInfo>
                                    <EventInfoWrap style={{marginTop: "10px"}}>
                                        <EventTitle><span>{singlePageEventData.eventName}</span></EventTitle>
                                     </EventInfoWrap> 

                                    <EventInfoWrap >
                                        <EventLocationDescription>
                                        <PiMapPinLineLight size={19}/>
                                        <span>{singlePageEventData.eventFormat === 'online' ? translate('events:create.online') : singlePageEventData.locationAddress}</span>
                                        </EventLocationDescription>
                                    </EventInfoWrap>
                                    {
                                        singlePageEventData.eventFormat === 'online' && singlePageEventData.onlineUrl && (
                                            <OnlineEventLink href={singlePageEventData.onlineUrl} target='_blank' rel='noreferrer'>
                                                {translate('events:actions.joinOnline')}
                                            </OnlineEventLink>
                                        )
                                    }
                                     
                                </EventInfo>
                                {
                                    coordinates && (
                                        <MapWrap>
                                            <MapContainer style={{height: '300px', position: "relative"}}>
                                                <OpenInGoogle onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${singlePageEventData.locationAddress}`)}>{ translate("web:events.openInGoogle") }</OpenInGoogle>
                                                <EventMap markerTitle={singlePageEventData.eventName} markerPosition={[singlePageEventData.coordinates.lat, singlePageEventData.coordinates.lng]} />
                                            </MapContainer>
                                        </MapWrap>
                                    )
                                }
                            </SinglePageLeft>
                            <SinglePageRight>
                                <TopRightItemContainer>
                                    <SectionButton>
                                        <SectionBtn active={contentView === 'details'} onClick={() =>setContentView('details')}>
                                            <TbListDetails size={20}/>{translate("web:events.details")}
                                        </SectionBtn>
                                        <SectionBtn disabled={privacy === 'private'} active={contentView === 'discussion'} onClick={() => setContentView('discussion')}>
                                            <GoCommentDiscussion size={20} /> { translate("web:events.discussion")  }
                                        </SectionBtn>
                                    </SectionButton>
                                </TopRightItemContainer>
                                <RightMainContent>
                                    {
                                        contentView === 'details' ? (
                                            <Details attending={attending} />
                                        ) : (
                                            <Discussion />
                                        )
                                    }
                                </RightMainContent>
                            </SinglePageRight>
                        </SinglePageWrap>
                    )
                )
            }
            <Modal open={viewRsvpModal} onClose={() => dispatch(setViewRsvpModal(false))}>
                <ModalContainer modalBody={ <RsvpModal attending={attending} attendingArray={singlePageEventData && singlePageEventData.attending} />} />
            </Modal>
        </SinglePageContainer>
    )
}

const MapWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 300px;
    margin-top: 20px;
    background-color: white ;
    border-radius: 10px;
    box-shadow: 0 0 10px #ccc;
    @media (max-width: 768px) {
        margin-top: 10px;
    }
`
const MapContainer = styled.div`
  position: relative;
  min-height: 200px;
  height: 100%;
  width: 100%; 
  border-radius: 10px; 
  border: 1px solid #d6d6d6; 
`
const OpenInGoogle = styled(pBtnSmall)` 
  position: absolute;
  top: 5px;
  border: 1px solid #b0b0b0; 
  background-color: white;
  right: 5px;
  z-index: 999; 
`
const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    width: 100%;
    height: 50%;
    background-color: white;
    @media (max-width: 768px) {
        height: 100%;
    }
`
const EventInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    padding: 10px;
    background-color: white;
    border-radius: 0px 0px 15px 15px;
    box-shadow: 0 0 10px #ccc;
    @media (max-width: 768px) { 
        height: 100%;
    }
`
const EventInfoWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    height: fit-content;
    padding: 5px 10px;
    @media (max-width: 768px) {
        padding: 0px;
    }
`
const ChurchInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: fit-content;
    padding: 10px;
    border-bottom: 1px solid #ececec;
    @media (max-width: 768px){
        padding: 10px;
    }
`
const ChurchImage = styled.div`
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`
const ChurchName = styled.div`
    font-size: 15px;
    color: var(--lightThemeSecondaryFontColor);
    font-weight: 500;
    padding: 10px;
    @media (max-width: 768px) {
        padding-left: 10px;
    }
`
const EventTitle = styled.div`
    font-size: 17px;
    color: var(--lightThemeFontColor);
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width: 768px) {
        margin-top: 10px;
    }
` 

const EventLocationDescription = styled.span`
    font-size: 15px;
    color: var(--lightThemeSecondaryFontColor);
    font-weight: 500; 
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    @media (max-width: 768px) {
        padding-left: 10px;
    }
`
const OnlineEventLink = styled.a`
    align-self: flex-start;
    margin-top: 10px;
    padding: 9px 14px;
    border-radius: 8px;
    background: var(--themeColor);
    color: white;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
`
